import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { track } from 'web/lib/service/analytics'

export const Footer = ({ showAbout = false }: { showAbout?: boolean }) => {
  const { t } = useTranslation()
  return (
    <div className="text-ink-400 mb-4 mt-8 w-full text-center text-sm">
      {t('footer.copyright')}
      <span className="mx-2">&bull;</span>
      {showAbout && (
        <>
          <Link href="/about" className="hover:underline">
            {t('footer.about')}
          </Link>
          <span className="mx-2">&bull;</span>
        </>
      )}
      <a
        href="/terms"
        target="_blank"
        className="hover:underline"
        onClick={() => track('Click TOS')}
      >
        {t('footer.terms')}
      </a>
      <span className="mx-2">&bull;</span>
      <a
        href="/privacy"
        target="_blank"
        className="hover:underline"
        onClick={() => track('Click Privacy')}
      >
        {t('footer.privacy')}
      </a>
    </div>
  )
}
